// extracted by mini-css-extract-plugin
export default {"card":"SmallCardImg_card__Tivmz","imgBox":"SmallCardImg_imgBox__o6cUO","img":"SmallCardImg_img__s8gIU"};